import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { msgAppAccessService } from '../msgappaccess.service';

@Component({
    selector: 'app-messages-dialog',
    templateUrl: './messages-dialog.component.html',
    styleUrls: ['./messages-dialog.component.scss'],
    standalone: false
})
export class MessagesDialogComponent implements OnInit {
  safeUrl: SafeResourceUrl;



  constructor(
    private sanitizer: DomSanitizer,
    //public lang: LanguageService,
    public dialogRef: MatDialogRef<MessagesDialogComponent>,
    public msgAppAccessService: msgAppAccessService, 
    @Inject(MAT_DIALOG_DATA) public data:any

  ) { }



  ngOnInit(): void {
    const messagingAppUrl = 'https://msg.artisansonics.com/message-center';
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(messagingAppUrl);
  }
  
  closeDialog() {
    this.dialogRef.close();
  }
  minimizeDialog(): void {
    this.msgAppAccessService.minimize();
  }
}
